import { useEffect, useState } from 'react'
import { getReportAttendanceDropPositionsAPI } from '../../../services/report/attendanceSum'

function UseReportAttendanceDropPositions(orgId, groupId, dmId, teamId) {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])

  useEffect(() => {
    let ignore = false

    const getData = async () => {
      const params = { orgId }
      if (groupId) params.groupId = groupId
      if (dmId) params.dmId = dmId
      if (teamId) params.teamId = teamId
      
      const resp = await getReportAttendanceDropPositionsAPI(params)
      
      if (ignore || !resp) return
      
      if (resp.status) {
        setRawData(resp.result)
        const newData = resp.result.map((d) => ({
          value: d?.positionEn || d?.position,
          label: d?.position
        }))
        setOptions(newData)
      } else {
        setOptions([])
        setRawData([])
      }
    }

    if (orgId) {
      getData()
    }

    return () => {
      ignore = true
    }
  }, [orgId, groupId, dmId, teamId])

  return { options, rawData }
}

export default UseReportAttendanceDropPositions
